<template>
  <el-dialog :title="dialog.title" :visible.sync="dialog.visible" width="680px" append-to-body>
    <el-table :data="table.bodys" highlight-current-row stripe border :row-key="table.id" max-height="600px">
      <el-table-column label="资源位 code" prop="resourceItemCode" align="center"></el-table-column>
      <el-table-column label="操作时间" prop="time" width="180px" align="center"></el-table-column>
      <el-table-column label="操作人" prop="operator" align="center"></el-table-column>
      <el-table-column label="操作类型" prop="op" align="center">
        <template v-slot="{ row }">
          {{ row.op | optionsPipe(options.type) }}
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { getResourceLog } from "@/api/desk/notice";
export default {
  name: "resource-item-operate-log-dialog",
  data() {
    return {
      dialog: {
        loading: false,
        visible: false,
        title: "操作日志"
      },
      options: {
        type: [
          { label: "新增", value: 1 },
          { label: "修改", value: 2 },
          { label: "删除", value: 3 }
        ]
      },
      table: {
        rowKey: "id",
        bodys: []
      }
    };
  },

  methods: {
    show(row) {
      // TODO: 根据 接口查询条件
      this.fetchList(row)
        .then(() => {
          this.dialog.visible = true;
        })
        .catch(err => {
          console.error(this.$options.name, err);
        });
    },
    hide() {
      this.dialog.visible = false;
    },
    async fetchList(row) {
      // TODO: 查询操作列表接口
      const { data } = await getResourceLog({
        itemId: row.id,
      })

      this.table.bodys = data.data
      console.log("🚀 ~ file: resource-item-operate-log-dialog.vue:55 ~ data", data);
      // return Promise.resolve([
      //   {
      //     id: 1,
      //     code: "1",
      //     updateTime: "2020-02-02 02:02:02",
      //     updateUser: "admin",
      //     type: 1
      //   },
      //   {
      //     id: 2,
      //     code: "2",
      //     updateTime: "2020-02-02 02:02:02",
      //     updateUser: "admin",
      //     type: 2
      //   },
      //   {
      //     id: 3,
      //     code: "3",
      //     updateTime: "2020-02-02 02:02:02",
      //     updateUser: "admin",
      //     type: 3
      //   }
      // ])
      //   .then(res => {
      //     this.table.bodys = res;
      //   })
      //   .catch(err => {
      //     console.log(
      //       "🚀 ~ file: resource-item-operate-log-dialog.vue:91 ~ err:",
      //       err
      //     );
      //   });
    }
  }
};
</script>

<style lang="scss" scoped></style>
